import React from 'react'
import "./Services.css"
import { TfiLayoutLineSolid } from "react-icons/tfi";
import { RiArrowRightLongLine } from "react-icons/ri"


const Services = () => {
    const DEMAT_LINK = "https://mosl.co/MOSWEB/xwcaiDZIkj";
    return (
        <div className='services-main' id='ser'>
            <div className="services-container">
                <div className="services-top">
                    <div className="services-title">
                        <span><TfiLayoutLineSolid /> The Ledger
                        </span>
                    </div>
                    <div className="services-text">
                        <span>Every entry, a service.
                        </span>
                    </div>
                    <div className="services-line">
                        <p>What we offer as an authorized Motilal Oswal business associate — confirm and refine against the client's real service list once shared.</p>
                    </div>
                    <div className="services-disclaimer">
                        <p>
                            <strong>Disclaimer:</strong> To access any of the services below, you must first{" "}
                            <a href={DEMAT_LINK} target="_blank" rel="noopener noreferrer">
                                open a demat account
                            </a>{" "}
                            with <span className='profit-station--green'>Profit Station</span> (Motilal Oswal). Once your account is active, you can proceed with the individual services listed.
                        </p>
                        <a
                            href={DEMAT_LINK}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="disclaimer-cta-btn"
                        >
                            Open Demat Account Now
                        </a>
                    </div>
                </div>

                <div className="services-tags">
                    <div className="service-tag">
                        <div className="tag-count">
                            <span>EQ / 01</span>
                        </div>
                        <div className="tag-name">
                            <span>
                                Equity & Stock Broking</span>
                        </div>
                        <div className="tag-about">
                            <p>Trading and demat access backed by MOFSL research, execution infrastructure, and real-time market tools.</p>
                        </div>
                        <div className="tag-link">
                            <a href="https://www.motilaloswal.com/share-market">Learn more<RiArrowRightLongLine /></a>
                        </div>
                    </div>
                    <div className="service-tag">
                        <div className="tag-count">
                            <span>EQ / 02</span>
                        </div>
                        <div className="tag-name">
                            <span>

                                Mutual Funds</span>
                        </div>
                        <div className="tag-about">
                            <p>Curated fund selection matched to goals, horizon, and risk appetite, with regular performance reviews.</p>
                        </div>
                        <div className="tag-link">
                            <a href="https://www.motilaloswal.com/mutual-funds">Learn more<RiArrowRightLongLine /></a>
                        </div>
                    </div>

                    <div className="service-tag">
                        <div className="tag-count">
                            <span>EQ / 03</span>
                        </div>
                        <div className="tag-name">
                            <span>
                                Portfolio & Wealth Management</span>
                        </div>
                        <div className="tag-about">
                            <p>Straightforward application support and allotment tracking for upcoming public offerings</p>
                        </div>
                        <div className="tag-link">
                            <a href="https://www.motilaloswal.com/portfolio-management-services">Learn more<RiArrowRightLongLine /></a>
                        </div>
                    </div>


                    <div className="service-tag">
                        <div className="tag-count">
                            <span>EQ / 04</span>
                        </div>
                        <div className="tag-name">
                            <span>
                                IPO & New Listings Access</span>
                        </div>
                        <div className="tag-about">
                            <p>Straightforward application support and allotment tracking for upcoming public offerings.</p>
                        </div>
                        <div className="tag-link">
                            <a href="https://www.motilaloswal.com/ipos">Learn more<RiArrowRightLongLine /></a>
                        </div>
                    </div>
                    <div className="service-tag">
                        <div className="tag-count">
                            <span>EQ / 05</span>
                        </div>
                        <div className="tag-name">
                            <span>
                                Commodities</span>
                        </div>
                        <div className="tag-about">
                            <p>Natural resources that are mined or extracted, including precious metals (gold, silver) and energy products (crude oil, natural gas).</p>
                        </div>
                        <div className="tag-link">
                            <a href="https://www.motilaloswal.com/commodity-market">Learn more<RiArrowRightLongLine /></a>
                        </div>
                    </div>
                    <div className="service-tag">
                        <div className="tag-count">
                            <span>EQ / 06</span>
                        </div>
                        <div className="tag-name">
                            <span>
                                Tax-Efficient Planning</span>
                        </div>
                        <div className="tag-about">
                            <p>Investment structuring that keeps an eye on your tax outcome, not just your returns.</p>
                        </div>
                        <div className="tag-link">
                            <a href="https://www.motilaloswal.com/fd">Learn more<RiArrowRightLongLine /></a>
                        </div>
                    </div>




                </div>
            </div>
        </div>
    )
}

export default Services